import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { Button, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';

const MonitoringForm = ({ onCancel }) => {
  const {
    values,
    errors,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue
  } = useFormikContext();

  const typeOptions = [
    { label: 'Egg', value: 'egg' },
    { label: 'Trap', value: 'trap' }
  ];

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='date'>
          <Form.Label>Date</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={(values.date || '').slice(0, 10)}
            placeholder='Select date'
            isInvalid={!!errors.date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.date}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='amount'>
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.amount}
            placeholder=''
            isInvalid={!!errors.amount}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.amount}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='type'>
          <Form.Label>Type</Form.Label>
          <Select
            name='type'
            placeholder='Select type...'
            options={typeOptions}
            value={typeOptions.find((to) => to.value === values.type)}
            onChange={(option) => {
              setFieldValue('type', option.value);
            }}
            styles={{
              control: (base) => ({
                ...base,
                ...(errors.type && { borderColor: '#dc3545' })
              })
            }}
          />
          {errors.type ? (
            <small className='text-danger'>{errors.type}</small>
          ) : null}
        </Form.Group>
        <Button variant='primary' type='submit'>
          {isSubmitting ? (
            <Spinner className='mx-3' animation='border' size='sm' />
          ) : (
            'Submit'
          )}
        </Button>{' '}
        <Button variant='secondary' type='button' onClick={onCancel}>
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default observer(MonitoringForm);

